import Immutable from "immutable";
import RecordClassCreator, { RecordAttributeMapper } from "services/record";
import { CSATSatisfactionStyle } from "services/csat/types";
import {
  CSATSettingsFeedbackOption,
  TranslationMap
} from "./helpers";

export interface CSATSettingsAttributes {
  surveyIsActive?: boolean;
  satisfactionStyle?: CSATSatisfactionStyle;
  satisfactionRange?: 2 | 5;
  satisfactionLabel: TranslationMap;
  followUpFeedbackIsEnabled?: boolean;
  followUpFeedbackNegativeLabel: TranslationMap;
  followUpFeedbackPositiveLabel: TranslationMap;
  followUpPositiveFeedbackOptions: Immutable.List<CSATSettingsFeedbackOption>;
  followUpNegativeFeedbackOptions: Immutable.List<CSATSettingsFeedbackOption>;
  resolutionIsEnabled?: boolean;
  resolutionLabel: TranslationMap;
  openFeedbackIsEnabled?: boolean;
  openFeedbackLabel: TranslationMap;
  respondToNegativeFeedback?: boolean;
  anytimeSurveyIsEnabled?: boolean;
}

export default class CSATSettings extends RecordClassCreator<CSATSettingsAttributes>({
  type: "csatSettings",

  surveyIsActive: false,
  satisfactionStyle: CSATSatisfactionStyle.EMOJI,
  satisfactionRange: 5,
  satisfactionLabel: null,
  followUpFeedbackIsEnabled: false,
  followUpFeedbackNegativeLabel: null,
  followUpPositiveFeedbackOptions: Immutable.List(),
  followUpNegativeFeedbackOptions: Immutable.List(),
  followUpFeedbackPositiveLabel: null,
  resolutionIsEnabled: false,
  resolutionLabel: null,
  openFeedbackIsEnabled: false,
  openFeedbackLabel: null,
  respondToNegativeFeedback: false,
  anytimeSurveyIsEnabled: true
}) {
  static attributeMapper: RecordAttributeMapper<CSATSettingsAttributes> = {
    followUpPositiveFeedbackOptions: (value: {
      id: string;
      label: Record<string, string>;
    }[]) => value.map(option => (
      new CSATSettingsFeedbackOption({
        id: option.id,
        label: Immutable.Map(option.label)
      })
    )),
    followUpNegativeFeedbackOptions: (value: {
      id: string;
      label: Record<string, string>;
    }[]) => value.map(option => (
      new CSATSettingsFeedbackOption({
        id: option.id,
        label: Immutable.Map(option.label)
      })
    ))
  };
}
